import { Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { EvalBidDto } from "../../../../autogen/bff-api";
import { formatEstimatedValue } from "../../../sourcing-events/portal/utils/displayFormatters";

export const EvaluationFocusStats = ({ bid }: { bid: EvalBidDto }) => {
  const { t } = useTranslation();
  const price = bid.effectivePrice;

  return (
    <Flex align="baseline" justify="space-between" gap="4" flexWrap="wrap">
      <Text fontSize="sm" color="smMuted">
        {t("Total price")}:{" "}
        <Text as="span" fontWeight="bold" color="smText">
          {price?.value != null ? formatEstimatedValue(price.value, price.currency) : "–"}
        </Text>
      </Text>
      <Text fontSize="sm" color="smMuted">
        {t("Total weighted score")}:{" "}
        <Text as="span" fontWeight="bold" fontFamily="mono" color="smText">
          {bid.weightedTotal.toFixed(1)}
        </Text>
      </Text>
    </Flex>
  );
};
